<template>
  <v-container class="py-0 px-1">
    <v-form ref="pagtosPublicadosForm">
      <v-row>
          <v-col class="py-0 px-2" cols="2">
            <label>Data entre</label>
            <v-menu
                ref="dtI"
                v-model="dtI"
                :close-on-content-click="true"
                transition="scale-transition"
                offset-y
            >
                <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="dateIFormatted"
                    dense
                    v-mask="'##/##/####'"
                    format="DD/MM/YYYY"
                    placeholder="DD/MM/YYYY"
                    label
                    outlined
                    v-bind="attrs"
                    v-on="on"
                    append-icon="mdi-calendar-blank"
                    @blur="dateI = parseDate(dateIFormatted)"
                    :rules="[formData.status!=false ?formRules.requiredField : true, formRules.typeDateFormated]"
                ></v-text-field>
                </template>
                <v-date-picker color="primary"  v-model="dateI" no-title scrollable></v-date-picker>
            </v-menu>
          </v-col>
          <v-col class="py-0 px-2" cols="2">
            <label>até</label>
            <v-menu
                ref="dtF"
                v-model="dtF"
                :close-on-content-click="true"
                transition="scale-transition"
                offset-y
            >
                <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="dateFFormatted"
                    v-mask="'##/##/####'"
                    format="DD/MM/YYYY"
                    placeholder="DD/MM/YYYY"
                    label
                    dense
                    outlined
                    v-bind="attrs"
                    v-on="on"
                    append-icon="mdi-calendar-blank"
                    @blur="dateF = parseDate(dateFFormatted)"
                    :rules="[formRules.typeDateFormated]"
                ></v-text-field>
                </template>
                <v-date-picker color="primary"  v-model="dateF" no-title scrollable></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="6" md="3" class="px-3 py-0">
            <label>Prestador</label>
            <v-autocomplete
              v-model="formData.prestador_id"
              :items="prestadoresFilter"
              item-value="id"
              item-text="prest_nome"
              label="Selecione"
              multiple
              chips
              outlined
              flat
              solo
              dense
              filled
              :disabled="prestadoresFilter.length==1"
              :search-input.sync="searchInput" 
            >
          <template v-slot:item="data">
            <v-list-item @click="toggleAutocomplete(data.item, 'prestador_id')" :class="formData.prestador_id.includes(data.item.id)? 'primary--text v-list-item--active': ''">
              <v-list-item-content>
                <v-list-item-title>{{data.item.prest_nome}}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
        </template>
          <template v-slot:selection="data">
            <v-chip v-if="data.index < 2" small label class="ma-1" :style="formData.prestador_id.length>1? 'max-width:28%':'max-width:90%'">{{
              data.item.prest_nome
            }}</v-chip>
            <span v-if="data.index == 2" class="ml-2 grey--text caption">
              (+{{
                formData.prestador_id.length == 3
                  ? formData.prestador_id.length - 2 + " outro"
                  : formData.prestador_id.length - 2 + " outros"
              }})
            </span>
          </template>
        </v-autocomplete>
      </v-col>
          <!-- <v-col class="py-0 px-2" cols="2">
            <label>Prestador</label>
            <v-select
                v-model="formData.prestador_id"
                :items="prestadoresFilter"
                item-value="id"
                item-text="prest_nome"
                :menu-props="{ bottom: true, offsetY: true }"
                flat
                solo
                dense
                outlined
            ></v-select>
          </v-col> -->
           <v-col cols="12" sm="6" md="3" class="px-3 py-0">
            <label>Operadoras</label>
            <v-autocomplete
              v-model="formData.operadora_ans_id"
              :items="operadorasFilter"
              item-value="id"
              item-text="oper_nome"
              label="Selecione"
              multiple
              chips
              outlined
              flat
              solo
              dense
              filled
              :disabled="operadorasFilter.length==1"
              :search-input.sync="searchInput" 
            >
          <template v-slot:item="data">
            <v-list-item @click="toggleAutocomplete(data.item, 'operadora_ans_id')" :class="formData.operadora_ans_id.includes(data.item.id)? 'primary--text v-list-item--active': ''">
              <v-list-item-content>
                <v-list-item-title>{{data.item.oper_nome}}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
        </template>
          <template v-slot:selection="data">
            <v-chip v-if="data.index < 2" small label class="ma-1" :style="formData.operadora_ans_id.length>1? 'max-width:28%':'max-width:90%'">{{
              data.item.oper_nome
            }}</v-chip>
            <span v-if="data.index == 2" class="ml-2 grey--text caption">
              (+{{
                formData.operadora_ans_id.length == 3
                  ? formData.operadora_ans_id.length - 2 + " outro"
                  : formData.operadora_ans_id.length - 2 + " outros"
              }})
            </span>
          </template>
        </v-autocomplete>
      </v-col>
          <v-col cols="2"></v-col>
          <!-- <v-spacer></v-spacer> -->
          <v-col class="py-0 px-2" cols="2">
            <label>Status</label>
            <v-select
                v-model="formData.status"
                :items="eventoFilter"
                item-value="id"
                item-text="descricao"
                :menu-props="{ bottom: true, offsetY: true }"
                flat
                solo
                dense
                outlined
            ></v-select>
          </v-col>
          <v-col class="pt-0 pb-2 px-2" cols="2">
            <label>Pesquisar por</label>
            <v-select
                v-model="typeSearch"
                :items="typeSearchList"
                item-value="id"
                item-text="descricao"
                :menu-props="{ bottom: true, offsetY: true }"
                flat
                solo
                dense
                outlined
                @change="formData.nota_fiscal = null; formData.protocolo = null; formData.num_lote = null; search = null"
            ></v-select>
          </v-col>
          <v-col class="pt-5 pb-2 px-3" cols="3">
            <!-- <label>Nota Fiscal</label> -->
            <v-text-field
                v-model="search"
                prepend-inner-icon="mdi-magnify"
                :placeholder="typeSearch == 1 ?'Número da nota fiscal' :typeSearch == 2 ?'Número do protocolo' :typeSearch == 3 ?'Número do lote' :null"
                single-line
                outlined
                dense
                hide-details
                :disabled="typeSearch == null"
                @input="typeSearch == 1 ?formData.nota_fiscal = search :typeSearch == 2 ?formData.protocolo = search :typeSearch == 3 ?formData.num_lote = search :null"
            ></v-text-field>
          </v-col>
          <v-col class="d-flex justify-end pt-5 px-2">
              <v-spacer></v-spacer>
              <v-btn
                small 
                height="32px"
                color="primary"
                class="px-1 mr-3"
                depressed
                @click="sendFilter()"
                >Filtrar</v-btn>
              <v-btn
                outlined
                small 
                height="32px"
                color="primary"
                class="px-1 ml-1"
                depressed
                @click="reset()"
                >Limpar Filtro</v-btn>
          </v-col>
      </v-row>
      <v-row>
           
          
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import { mapActions, mapState  } from 'vuex'
export default {
    data() {
        return{
            dtI: false,
            dateI:null,
            dateIFormatted: null,
            dtF: false,
            dateF: null,
            dateFFormatted: null,
            eventoFilter: [
                { id: null, descricao: 'Selecione', color: null },
                { id: true, descricao: "Quitados", color: "#32B88B" },
                { id: false, descricao: "Aguardando quitação", color: "#FFA500"}
            ],
            typeSearchList: [
              { id: null, descricao: 'Selecione'},
              { id: 1, descricao: "Nota fiscal"},
              { id: 2, descricao: "Protocolo"},
              { id: 3, descricao: "N° Lote"}
            ],
            typeSearch: null,
            search: null,
            formData: {
                grupo_economico: this.$store.state.permissions.grupoEconomico,
                dt_fim: null,
                dt_inicio: null,
                nota_fiscal: null,
                protocolo: null,
                num_lote: null,
                operadora_ans_id: [],
                prestador_id: [],
                status: null,
                mes_corrente: false,
                powerFilter: false,
            },
            operadorasFilter: [],
            prestadores: [],
            prestadoresFilter: [],
            currentValue: false,
            qtdDays: 30,
            searchInput: null,
            
        }
    },
    async mounted() {
        this.prestadores = await this.$store.getters["permissions/getPrestadoresByGeco"]()
        this.updatePrestadores()
        let opts = {
            grupoEconomico: this.formData.grupo_economico,
            modulo_operadora: "recebiveis",
            prestador_ids: []
        }
        await this.getOperadoras(opts)
        let filtroExterno = null
        await this.$store.dispatch("recebiveis/getFilter",'pagamentosPublicados',  { root: true }).then(
            resp => filtroExterno = resp
        )
        this.formData.grupo_economico = this.$store.state.permissions.grupoEconomico
        if(filtroExterno){
            this.formData = Object.assign(this.formData,{...filtroExterno})
            this.dateIFormatted = this.formatDate(this.formData.dt_inicio)
            this.dateFFormatted = this.formatDate(this.formData.dt_fim)
        }
        this.filterList(this.formData)
    },
    computed:{
        ...mapState({
            operadoras: (state) => state.faturamento.listOperadora,
            formRules: (state) => state.formRules,
        })
    },
    watch: {
        grupoEconomicoList:{
            deep: true,
            handler() {
                this.prestadores = this.$store.getters["permissions/getPrestadoresByGeco"]();
            }
        },
        dateF(val){
          if (!val) {
            this.dateFFormatted = null
          } else {
            if (!!this.dateI && Date.parse(this.dateI) > Date.parse(val)){
              this.dateI = val
            }
            this.dateFFormatted = this.formatDate(val)
          }
        },
        dateFFormatted(val){
          this.formData.dt_fim = this.parseDate(val)
        },
        dateI(val){
          if (!val) {
            this.dateIFormatted = null
          } else {
            if (!!this.dateF && Date.parse(this.dateF) < Date.parse(val)){
              this.dateF = val
            }
            this.dateIFormatted = this.formatDate(val)
          }
        },
        dateIFormatted(val){
          this.formData.dt_inicio = this.parseDate(val)
        },
        mesCorrente: {
            deep: true,
            handler(val){
                if (val.dt_inicio != '0001-01-01' || val.dt_fim != '0001-01-01') {
                    this.dateI = val.dt_inicio
                    this.dateF = val.dt_fim
                    setTimeout(() => {this.currentValue = true},100)
                }
            }
        },
        prestadores:{
            deep: true,
            handler(){
                this.updatePrestadores()
            }
        },
        operadoras:{
            deep: true,
            handler(){
                this.updateOperadoras()
            }
        },
    },
    methods: {

        ...mapActions('permissions', [
            "getOperadoras"
        ]),
        changePrestador(){
            let opts = {
              grupo_economico: this.formData.grupo_economico,
              modulo_operadora: "recebiveis",
              prestador_ids: this.formData.prestador_id,
            }
            this.getOperadoras(opts).then(()=> {
                this.updateOperadoras()
            })
        },
        reset() {
            this.formData.status = null
            this.formData.dt_fim = null
            this.dateF = null
            this.formData.dt_inicio = null
            this.dateI = null
            this.formData.nota_fiscal = null
            this.formData.protocolo = null
            this.formData.num_lote = null
            this.formData.mes_corrente = false
            this.formData.powerFilter = true
            this.search = null
            this.typeSearch = 1
            if (this.prestadoresFilter.length>1) 
              this.formData.prestador_id = []
            this.formData.operadora_ans_id = []
            this.changePrestador()
            this.$nextTick(()=>{
              this.filterList(this.formData, 1, false)
              this.$refs.pagtosPublicadosForm.resetValidation()
            })
        },
        updatePrestadores(){
          this.prestadoresFilter = Array.from(this.prestadores)
          if(this.prestadores.length==1){
            this.formData.prestador_id = [this.prestadores[0].id]
            this.changePrestador(this.formData.prestador_id)
          } else {
            this.formData.prestador_id = []
          }
        },
        updateOperadoras(){
          this.operadorasFilter = Array.from(this.operadoras)
          if(this.operadorasFilter.length==1){
            this.formData.operadora_ans_id = [this.operadorasFilter[0].id]
          } else {
            this.formData.operadora_ans_id =  this.formData.operadora_ans_id.filter(el => this.operadorasFilter.findIndex(item=> item.id== el)>-1 )
          }
        },
        formatDate (date) {
        if (!date) return null
        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      parseDate (date) {
          if (!date) return null
          const [day, month, year] = date.split('/')
          return `${year}-${month}-${day}`
      },
      sendFilter(){
            
            this.formData.sort = this.sortt
            this.formData.order = this.orderr
            this.formData.mes_corrente = false
            this.formData.powerFilter = false
            if(this.$refs.pagtosPublicadosForm.validate()){
             if(!this.formData.dt_fim && this.formData.dt_inicio) {
                this.dateF = this.formData.dt_inicio
                this.formData.dt_fim = this.formData.dt_inicio
                }
                this.filterList(this.formData)
            }
        },
         toggleAutocomplete(item, campo) {
          this.searchInput=null
          let index = this.formData[campo].indexOf(item.id)
          //  index > -1  está excluindo a operadora
          if (index > -1) {
            this.formData[campo].splice(index, 1)
          } else {
            //  index < 0  está adicionando a operadora
              this.formData[campo].push(item.id)
          }
            this.$nextTick(()=> {if(campo=='prestador_id'){this.changePrestador()}})
            return
        },
    },
    props: {
        filterList: Function,
        mesCorrente: Object,
        orderr: String,
        sortt: String,
    }
}
</script>

<style>
.v-text-field--filled.v-input--dense.v-text-field--single-line .v-label, .v-text-field--full-width.v-input--dense.v-text-field--single-line .v-label {
    top: 7px;
}
</style>